export var LOADING = 'loading';
export var FAVORITE = 'favorite';
export var NOTIFY_ME = 'notifyMe';
export var NOTIFICATION = 'notification';
export var NOTIFICATION_FILLED = 'notificationFilled';
export var IMG = 'img';
export var ALT_IMG = 'alt-img';
export var RATING = 'rating';
export var SHADES = 'shades';
export var QUICK_BUY = 'quick-buy';
//# sourceMappingURL=constants.js.map